import { ActionCreator, AnyAction, Reducer } from 'redux';
import { ThunkActionCreator } from 'shared/state';
import { fetchSitesPublishedMessages as doFetchSitesPublishedMessages } from 'shared/api/sites';

/**
 * Site actions
 */
export const FETCH_SITES_PUBLISHED_MESSAGES_PENDING =
  'duplo/sites/FETCH_SITES_PUBLISHED_MESSAGES_PENDING';
export const FETCH_SITES_PUBLISHED_MESSAGES_FULFILLED =
  'duplo/sites/FETCH_SITES_PUBLISHED_MESSAGES_FULFILLED';
export const FETCH_SITES_PUBLISHED_MESSAGES_FAILED =
  'duplo/sites/FETCH_SITES_PUBLISHED_MESSAGES_FAILED';

export interface State {
  data: {
    sitePublishedMessages: Array<SitePublishedMessages>;
  };
  meta: StateMeta;
}

const defaultState: State = {
  data: {
    sitePublishedMessages: [],
  },
  meta: {
    pending: false,
  },
};

const reducer: Reducer<State> = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_SITES_PUBLISHED_MESSAGES_PENDING:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: true,
        },
      };
    case FETCH_SITES_PUBLISHED_MESSAGES_FULFILLED:
      return {
        ...state,
        data: {
          sitePublishedMessages: action.sitesPublishedMessages,
        },
        meta: {
          ...state.meta,
          pending: false,
          successful: true,
          error: null,
        },
      };
    case FETCH_SITES_PUBLISHED_MESSAGES_FAILED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Action creators
 */

const fetchSitesPublishedMessagesFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_PUBLISHED_MESSAGES_FAILED };
};

const fetchSitesPublishedMessagesPending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_PUBLISHED_MESSAGES_PENDING };
};

const fetchSitesPublishedMessagesFulfilled: ActionCreator<AnyAction> = (
  sitesPublishedMessages: Array<SitePublishedMessages>
) => {
  return {
    type: FETCH_SITES_PUBLISHED_MESSAGES_FULFILLED,
    sitesPublishedMessages,
  };
};

export const fetchSitesPublishedMessages: ThunkActionCreator = (
  siteId: number
) => dispatch => {
  dispatch(fetchSitesPublishedMessagesPending());
  doFetchSitesPublishedMessages(siteId)
    .then(fetchSitesPublishedMessages => {
      dispatch(
        fetchSitesPublishedMessagesFulfilled(fetchSitesPublishedMessages)
      );
    })
    .catch(_ => {
      dispatch(fetchSitesPublishedMessagesFailed());
    });
};
